import React from 'react';
import { useNavigate } from 'react-router-dom';

const ToolBox = () => {
  const navigate = useNavigate();

  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  const baseTools = [
    {
      id: 1,
      title: 'Doctor Schedule Generator',
      description: 'Provide a list of doctors pages URL then generate the doctor information and doctor schedule information in JSON format for IMPORT.',
      route: '/toolbox/doctor-schedule-generator',
    },
    {
      id: 2,
      title: 'QA Knowledge Base Generator',
      description: 'Provide a list of clinic pages URL then generate the QA knowledge base information in JSON format for IMPORT.',
      route: '/toolbox/qa-knowledge-base-generator',
      enabled: true,
    },
    {
      id: 3,
      title: 'Doctor Schedule Importer',
      description: 'Upload a JSON file containing clinic_doctors and clinic_doctor_schedules to import doctors and their schedules. The JSON can be exported from Clinic Config > Export > Export Clinic Config.',
      route: '/toolbox/doctor-schedule-importer',
      enabled: true,
    },
    {
      id: 8,
      title: 'Doctor Importer (No Schedule)',
      description: 'Import doctors only from JSON (e.g. Flexible Extract Doctor Page to Doctor List output). Schedules are not imported.',
      route: '/toolbox/doctor-importer-no-schedule',
      enabled: true,
    },
    {
      id: 9,
      title: 'Doctor Service Updater',
      description: 'Update service_provided for doctors. Provide doctor_name and services (CSV/JSON), map to clinic doctors, preview before/after, then apply.',
      route: '/toolbox/doctor-service-updater',
      enabled: true,
    },
    {
      id: 10,
      title: 'Bulk Doctor Schedule Editor',
      description: 'Add the same schedule to multiple doctors. Select clinic, configure schedule, tick doctors (Apply All), preview original vs updated, then confirm.',
      route: '/toolbox/doctor-schedule-editor',
      enabled: true,
    },
    {
      id: 11,
      title: 'Service-to-Doctor QA Generator',
      description: 'Generate QA from doctors\' service_provided. Select clinic, build service-to-doctor mapping, preview/edit, set tags, then import.',
      route: '/toolbox/service-doctor-qa-generator',
      enabled: true,
    },
    {
      id: 4,
      title: 'Conversation Messages Tool',
      description: 'List conversation messages with filtering by CLID, grouping by conversation ID, sorting by ID ascending, and pagination support.',
      route: '/toolbox/conversation-messages',
      enabled: true,
    },
    {
      id: 5,
      title: 'FindDoc Agent Analytics',
      description: 'View and analyze FindDoc Agent integration events including search, navigation, and booking activities.',
      route: '/toolbox/finddoc-agent-analytics',
    },
    {
      id: 12,
      title: 'HKSH Report Generator',
      description:
        'Select a month, pull HKSH flow comments and NPS quick-reply scoring from the database, merge and score like the playground notebook, preview tables, and download a ZIP with four CSVs.',
      route: '/toolbox/hksh-report',
      enabled: true,
    },
    {
      id: 13,
      title: 'OncoCare Survey Report',
      description:
        'Preview and export OncoCare patient NPS survey results (Q1–Q4) as CSV for a month or custom date range. Select CLID3596 (default) or DEMO0004 for testing.',
      route: '/toolbox/oncocare-survey-report',
      enabled: true,
    },
    {
      id: 7,
      title: 'Flexible URL Extractor',
      description: 'Provide a list of URLs, an instruction (prompt), and required fields (e.g. service, service_doctor_list). Extract structured data and export CSV or JSON.',
      route: '/toolbox/flexible-extract',
    },
    {
      id: 14,
      title: 'Bulk Upload Media',
      description: 'Upload a zip package of media files, preview each item with editable QA templates, then create Media records and optional QA knowledge in one batch.',
      route: '/toolbox/media-bulk-upload',
      enabled: true,
    },
    {
      id: 16,
      title: 'WATI Contact Segment Sync',
      description: 'Paste a list of phone numbers (e.g. copied from an Excel column). Check which already exist as WATI contacts, create the missing ones, then add them all to a new WATI segment.',
      route: '/toolbox/wati-contact-segment-sync',
      enabled: true,
    },
  ];

  const tools = [
    ...baseTools,
    ...(isLocalhost
      ? [
          {
            id: 6,
            title: 'Conversation Messages CSV Import (Local Only)',
            description: 'Upload a conversation_message CSV file (e.g. tests/conversation_message.csv) to import messages into the local database for testing.',
            route: '/toolbox/conversation-messages-import',
            enabled: true,
          },
          {
            id: 15,
            title: 'Conversation State Event Import (Local Only)',
            description: 'Upload a conversation_state_event CSV file (e.g. tests/conversation_state_event.csv) to import state events into the local database for testing.',
            route: '/toolbox/conversation-state-events-import',
            enabled: true,
          },
        ]
      : []),
  ];

  const handleToolClick = (tool) => {
    if (tool.route) {
      navigate(tool.route);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Tool Box</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {tools.map((tool) => (
          <div
            key={tool.id}
            onClick={() => handleToolClick(tool)}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow cursor-pointer hover:border-[#075e54]"
          >
            <h3 className="text-lg font-semibold text-gray-900 mb-3">{tool.title}</h3>
            <p className="text-sm text-gray-600">{tool.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ToolBox;

